module.exports = __webpack_public_path__ + "static/media/jack_summit_intro_small_10.7925b194.jpg";